<script setup lang="ts">
  import { IconArrowLeft, IconClear, Text } from "@ui-kit";
  import { TopBar, StatusBar } from "@src/components";

  const emit = defineEmits<{
    "click:back": [value: void];
    "click:clear": [value: void];
  }>();
</script>

<template>
  <div class="product-fitting-list" data-testid="product-fitting-list">
    <StatusBar />
    <TopBar
      :title="$t('Примерочные')"
      @click:left="() => emit('click:back')"
      @click:right="() => emit('click:clear')"
      data-testid="top-bar-fitting"
    >
      <template #left>
        <IconArrowLeft />
      </template>
      <template #right>
        <IconClear />
      </template>
    </TopBar>
    <div class="product-fitting-list__content">
      <slot />
      <Text font="body-regular-14" color="secondary" class="product-fitting-list__placeholder">
        {{ $t("Отсканируйте товар, чтобы он появился в списке") }}
      </Text>
    </div>
  </div>
</template>

<style scoped>
  .product-fitting-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    background-color: var(--sf-base-background-primary);
  }

  .product-fitting-list__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 8px;
    padding: 6px 16px;
    overflow-y: auto;
  }

  .product-fitting-list__placeholder {
    text-align: center;
  }
</style>
